function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFA64D"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.93005 35.3C7.93005 36.3 8.46005 37.07 9.11005 37.08H38.8401C39.4901 37.08 40.0201 36.28 40.0201 35.3V33.77H7.93005V35.3Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 13.53C38 12.9996 37.7893 12.4909 37.4143 12.1158C37.0392 11.7407 36.5305 11.53 36 11.53H11.92C11.3896 11.53 10.8809 11.7407 10.5058 12.1158C10.1308 12.4909 9.92004 12.9996 9.92004 13.53V33.77H38V13.53Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.08 30.3301C35.08 30.3847 35.0691 30.4389 35.0479 30.4893C35.0266 30.5397 34.9955 30.5854 34.9564 30.6236C34.9173 30.6618 34.8709 30.6918 34.82 30.7118C34.7691 30.7318 34.7147 30.7414 34.66 30.7401H13.29C13.1803 30.7401 13.075 30.6972 12.9965 30.6206C12.918 30.544 12.8726 30.4397 12.87 30.3301V14.8401C12.8726 14.7304 12.918 14.6261 12.9965 14.5495C13.075 14.4729 13.1803 14.43 13.29 14.4301H34.66C34.7147 14.4287 34.7691 14.4383 34.82 14.4583C34.8709 14.4784 34.9173 14.5083 34.9564 14.5465C34.9955 14.5848 35.0266 14.6304 35.0479 14.6808C35.0691 14.7312 35.08 14.7854 35.08 14.8401V30.3301Z",
  fill: "white",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 24.2899C23.6831 24.288 23.3728 24.3801 23.1084 24.5547C22.844 24.7293 22.6373 24.9785 22.5147 25.2707C22.3921 25.5629 22.3589 25.8849 22.4195 26.1959C22.4802 26.5069 22.6317 26.793 22.8551 27.0177C23.0785 27.2425 23.3635 27.3959 23.6742 27.4584C23.9848 27.521 24.307 27.4899 24.6 27.3691C24.8929 27.2483 25.1434 27.0432 25.3197 26.7799C25.4959 26.5166 25.59 26.2068 25.59 25.8899C25.5913 25.6803 25.5512 25.4725 25.4719 25.2784C25.3926 25.0843 25.2756 24.9079 25.1279 24.7592C24.9801 24.6105 24.8044 24.4925 24.6108 24.4119C24.4172 24.3314 24.2097 24.2899 24 24.2899Z",
  fill: "#292929"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3901 22.8999C26.9422 22.4503 26.41 22.0936 25.824 21.8502C25.238 21.6068 24.6096 21.4814 23.9751 21.4814C23.3405 21.4814 22.7121 21.6068 22.1261 21.8502C21.5401 22.0936 21.0079 22.4503 20.5601 22.8999",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.7 20.54C28.9493 19.7863 28.0571 19.1882 27.0747 18.7801C26.0922 18.3719 25.0388 18.1619 23.975 18.1619C22.9112 18.1619 21.8578 18.3719 20.8753 18.7801C19.8929 19.1882 19.0007 19.7863 18.25 20.54",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})));

function SvgTechnology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.7ce3bc1c.svg";
export { ForwardRef as ReactComponent };